import React from 'react';
import PropTypes from 'prop-types';

class Spoiler extends React.Component {
  state = {
    isOpened: false,
  };

  // static propTypes = {
  //   header: PropTypes.oneOfType(PropTypes.element, PropTypes.string),
  //   content: PropTypes.oneOfType(PropTypes.element, PropTypes.string),
  //   children: PropTypes.oneOfType(PropTypes.element, PropTypes.string),
  // };

  static defaultProps = {
    header: 'spoiler',
    content: null,
    children: null,
  };

  renderContent = this.props.content ? this.props.content : this.props.children;

  render() {
    const { disabled } = this.props;
    return (
      <div className={this.state.isOpened ? 'spoiler is-open' : 'spoiler'}>
        <div
          className="spoiler__head"
          onClick={() => {
            if (!disabled) this.setState({ isOpened: !this.state.isOpened });
          }}
        >
          {this.props.header}
        </div>
        <div className="spoiler__body">
          <div className="spoiler__block">{this.props.content}</div>
        </div>
      </div>
    );
  }
}

export default Spoiler;
